import { render, staticRenderFns } from "./SettingGame.vue?vue&type=template&id=4c433caa&scoped=true&lang=pug&"
import script from "./SettingGame.vue?vue&type=script&lang=js&"
export * from "./SettingGame.vue?vue&type=script&lang=js&"
import style0 from "./SettingGame.vue?vue&type=style&index=0&id=4c433caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c433caa",
  null
  
)

export default component.exports